const simpleNavBurger = document.querySelector(".simple-nav-burger");
const simpleNav = document.querySelector(".simple-nav");
const simpleNavOverlay = document.querySelector(".simple-nav-overlay");
const body = document.body;

if (simpleNavBurger) simpleNavBurger.addEventListener("click", handleClick);
if (simpleNavOverlay) simpleNavOverlay.addEventListener("click", handleClick);

function handleClick() {
  if (simpleNavBurger.classList.contains("simple-nav-active")) {
    simpleNavBurger.classList.remove("simple-nav-active");
    simpleNavOverlay.classList.remove("simple-nav-active");
    simpleNav.classList.remove("simple-nav-active");

    body.style.overflow = "";
    body.style.touchAction = "";
    body.style.webkitOverflowScrolling = "";
    body.style.overscrollBehavior = "";
  } else {
    simpleNavBurger.classList.add("simple-nav-active");
    simpleNavOverlay.classList.add("simple-nav-active");
    simpleNav.classList.add("simple-nav-active");

    body.style.overflow = "hidden";
    body.style.touchAction = "none";
    body.style.webkitOverflowScrolling = "none";
    body.style.overscrollBehavior = "none";
  }
}
